import {updateObject} from "../../shared/utils/utils";
import * as actionTypes from "./actionTypes";

const initialState = {
    users: {
        data: [],
        page: 0,
        rowsPerPage: 10,
        count: 0,
        loading: false
    },
    deleteDialog: {
        loading: false
    },
}

const setUsers = (state, action) => {
    return updateObject(state, {
        users: updateObject(state.users, {
            data: action.payload.data,
            page: action.page,
            rowsPerPage: action.rowsPerPage,
            count: action.payload.count
        })
    })
}

const setFieldUsers = (state, action) => {
    return updateObject(state, {users: updateObject(state.users, {[action.typeOf]: action.payload})})
}

const setDeleteDialogLoading = (state, action) => {
    return updateObject(state, {deleteDialog: updateObject(state.deleteDialog, {loading: action.value})})
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_USERS_SUCCESS:
            return setUsers(state, action);
        case actionTypes.SET_USERS_FIELD:
            return setFieldUsers(state, action);
        case actionTypes.SET_USER_DELETE_DIALOG_LOADING:
            return setDeleteDialogLoading(state, action);
        default:
            return state;
    }
}
